// extracted by mini-css-extract-plugin
export default {"card":"IImpS","name":"xiI47","prices":"BSPLo","actualPrice":"FkUCr","expiredPrice":"yZ8hy","discount":"Ppaj8","sizes":"LiRIN","quantity":"yX6Ei"};